<template>
  <!-- App -->
  <div>
    <router-view></router-view>
  </div>
</template>
<script>
// import eqheader from './components/eqheader'
import dwhome from './components/dwhome'

export default {
  name: 'app',
  components: {
    dwhome
  },
  data() {
    return {
    }
  },
  created: function() {

  },
  computed: {
  },
  methods: {
  }
}

</script>
<style lang="scss">
@import './assets/sass/main.scss';
</style>



// WEBPACK FOOTER //
// App.vue?1f008734